import MainIcons from '@/icons/main';
import React, { useState } from 'react';
import styles from '../styles.module.css';
import { setState } from '@/commonTypes';

export default function MoreTagButton({
  list,
  showMore,
  setShowMore,
  sliceNumber = 4,
  className = '',
}: {
  list?: any;
  showMore?: boolean;
  setShowMore?: setState<boolean>;
  sliceNumber: number;
  className?: string;
}) {
  return (
    <>
      {Number(list?.length) > sliceNumber + 1 && (
        <div className={`${styles.arrowIconContainer} ${className}`}>
          <MainIcons.ArrowIcon
            className={`${styles.arrowIcon} ${showMore && styles.rotateIcon}`}
            onClick={() => {
              setShowMore && setShowMore(!showMore);
            }}
            fill="var(--text-mid)"
            width="20px"
            height="20px"
          />
        </div>
      )}
    </>
  );
}
